/**
 * Created by shubham on 26/4/18.
 */

import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../config';
import { ErrorHandler } from '../../shared/services/error-handler.service';
import { HttpService } from '../../shared/services/http.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { CommonService } from '../../shared/services/common.service';
import { MdDialog,MdDialogRef } from '@angular/material';
import { DialogComponent, ShowApplicationsDialogComponent } from '../../dialog/dialog.component';


@Component({
    selector: 'subusers-request-view',
    template: require('./viewSubUsers.component.html'),
    providers: [HttpService, ErrorHandler]
})

export class ViewSubUsersRequestComponent {

    dialogRef;
    id: any;
    userDetails: any;
    formData: any = {};
    businessUnitsFlag: boolean = false;
    wPassIdFlag: boolean = false;
    businessUnitWithApplicationAndRoles = [];
    businessUnitWithAppRolesSubPartner = [];
    ownerFlag:boolean = false;
    emailUpdating:boolean=false;


    constructor(private router: Router,private route: ActivatedRoute,private httpService: HttpService,private dialog: MdDialog,
                private commonService: CommonService, private sessionHandler:SessionHandler) {

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        this.route.params.subscribe(params => {
            this.id = +params['id'];
        });

        if(this.userDetails){
            this.getRequestDataWithId();
        } else{
            this.httpService.noUserError();
        }

        this.commonService.subUsersView.subscribe((value) => {
            this.getRequestDataWithId();
        });

    }

    public getRequestDataWithId(){
        this.httpService.getRequest('partnerOperationsApi/v1/companyUser/'+ this.id).subscribe(
            res => { this.saveRequestData(res) },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveRequestData(res) {
        if(res){
            this.formData = res;
            this.commonService.changeViewData(this.formData, 'subUsersView');
            if(this.formData){
                if(this.formData.userId_WPASS){
                    this.wPassIdFlag = true;
                }
                if(this.formData.ownerWpassId){
                    this.ownerFlag = true;
                }
                /*if(this.formData.businessUnitWithApplicationAndRoles){
                    this.businessUnitWithApplicationAndRoles = this.formData.businessUnitWithApplicationAndRoles;

                    for(let appIndex in this.businessUnitWithApplicationAndRoles){
                        if(!this.businessUnitWithApplicationAndRoles[appIndex]['message']){
                            this.businessUnitWithApplicationAndRoles[appIndex]['message'] = "";
                        }
                    }
                }*/

                if(this.formData.businessUnitWithApplicationAndRoles){
                    this.businessUnitWithApplicationAndRoles = this.formData.businessUnitWithApplicationAndRoles;

                    for(let businessUnit in this.businessUnitWithApplicationAndRoles) {
                        for(let appAndRoles in this.businessUnitWithApplicationAndRoles[businessUnit]['applications']){
                            let temp = [];
                            temp['businessUnitName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['businessUnitName'];
                            temp['customerNumber'] = this.businessUnitWithApplicationAndRoles[businessUnit]['customerNumber'];
                            temp['applicationName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['applicationName'];
                            temp['selectedRoleNames'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['selectedRoleNames'];
                            temp['url'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['url'];

                            let actionObject = {};
                            if( this.businessUnitWithApplicationAndRoles[businessUnit]['statusCode'] != 'APPROVED' ){
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit];
                            } else {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles];
                            }
                            temp['statusCode'] = actionObject['statusCode'];
                            temp['status'] = actionObject['status'];
                            temp['message'] = actionObject['message'];

                            this.businessUnitWithAppRolesSubPartner.push(temp);
                        }
                    }
                }
            }
            this.httpService.onEnd();
        } else if(res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    }
    updateEmail() {
        var newEmail = $('#newEmail').val();
        console.log('newEmail:'+newEmail);
        if(!newEmail) {
            this.emailUpdating=false;
            return;
        }
        this.httpService.postRequest({email:newEmail,id:this.id},'userRegistrationsApi/v1/updateEmail').subscribe(
            res => { 
                this.httpService.onEnd();
                window.location.reload();
            },
            err => { this.httpService.onEnd(); }
        );
    }
    initUpdateEmail() {
        this.emailUpdating=true;
    }
    cancelUpdateEmail() {
        this.emailUpdating=false;
    }
    isEmailUpdating() {
        return this.emailUpdating
    }

    showApplicationsWithRoles(apps){
        this.dialogRef = this.dialog.open(ShowApplicationsDialogComponent);
        for(let appIndex in apps){
            if(!apps[appIndex]['message']){
                apps[appIndex]['message'] = "";
            }
        }
        this.dialogRef.componentInstance.apps = apps;
        this.dialogRef.componentInstance.profileFlag = true;
    }

    ngOnInit(){}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewRequest/viewSubUsers/viewSubUsers.component.ts